import React from 'react';


function MessageTemplateDialog({ 
  open, 
  onClose, 
  onConfirm, 
  messageTemplate, 
  onTemplateChange, 
  previewMessages 
}) {
  if (!open) return null;

  return (
    <div className="dialog-overlay" onClick={onClose}>
      <div className="dialog-content" onClick={e => e.stopPropagation()}>
        <h2 className="dialog-title">Preview Message Template</h2>
        <div className="dialog-body">
          <div className="form-group">
            <label htmlFor="messageTemplate">Message Template</label>
            <textarea
              id="messageTemplate"
              rows={4}
              value={messageTemplate}
              onChange={(e) => onTemplateChange(e.target.value)}
              className="message-input"
            />
          </div>
          <h3 className="preview-title">Preview Messages</h3>
          {previewMessages.map((preview, index) => (
            <div key={index} className="preview-box">
              <p className="preview-recipient">
                For: {preview.guestName}
              </p>
              <p className="preview-message">
                {preview.message}
              </p>
            </div>
          ))}
        </div>
        <div className="dialog-actions">
          <button className="message-button" onClick={onClose}>Cancel</button>
          <button className="message-button primary" onClick={onConfirm}>
            Proceed with Export
          </button>
        </div>
      </div>
    </div>
  );
}

export default MessageTemplateDialog;
